import api from './api';

export interface Cartera {
    nroBanco: number;
    nombreBanco: string;
    tipoDeCuenta?: string;
    nroDeCuenta?: string;
    cbu?: string;
    titular?: string;
    sucursal?: string;
    nroCtaCble?: number;
    mcpPermitidos1?: number;
    mcpPermitidos2?: number;
    mcpPermitidos3?: number;
    mcpPermitidos4?: number;
    mcpPermitidos5?: number;
    mcpPermitidos6?: number;
    mcpPermitidos7?: number;
    mcpPermitidos8?: number;
    mcpPermitidos9?: number;
    mcpPermitidos10?: number;
    [key: string]: any; // Para campos adicionales que puedan venir del backend
}

export interface CarteraSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface CarteraPagedResult {
    items: Cartera[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

export interface SaldoCartera {
    nroBanco: number;
    nombreBanco: string;
    tipoDeCuenta: string;
    nroDeCuenta: string;
    cbu: string;
    titular: string;
    sucursal: string;
    nroCtaCble: number;
    mcpPermitidos1: number;
    mcpPermitidos2: number;
    mcpPermitidos3: number;
    mcpPermitidos4: number;
    mcpPermitidos5: number;
    mcpPermitidos6: number;
    mcpPermitidos7: number;
    mcpPermitidos8: number;
    mcpPermitidos9: number;
    mcpPermitidos10: number;
    saldo: number;
    saldoDebe: number;
    saldoHaber: number;
}

export interface SaldosCarteraSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    tipoDeCuenta?: string;
}

export interface SaldosCarteraResponse {
    items: SaldoCartera[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

export interface MovimientoCartera {
    nroFormulario: number;
    nroTipoFormulario: string;
    nombreTipoFormulario: string;
    nroSuc: number;
    fechaEmision: string;
    codigoCaja: number;
    usuario: string;
    nombre: string;
    descripcion: string;
    letra: string;
    nroComprobante: number;
    letraSucNum: string;
    debe?: number;
    haber?: number;
    saldoAcumulado?: number;
    mcp?: string;
    tipoPago?: string;
    detalle?: string;
    importe?: number;
    nroCuenta?: number;
    ingresoEgreso?: string;
}

export interface MovimientosCarteraSearchParams {
    pageNumber: number;
    pageSize: number;
    fechaDesde?: string;
    fechaHasta?: string;
    searchTerm?: string;
}

export interface MovimientosCarteraResponse {
    items: MovimientoCartera[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const carteraService = {
    getCarteras: async (params: CarteraSearchParams): Promise<CarteraPagedResult> => {
        const response = await api.get<CarteraPagedResult>('/api/CarteraBancos', { 
            params: {
                SearchTerm: params.searchTerm,
                PageNumber: params.pageNumber,
                PageSize: params.pageSize
            }
        });
        return response.data;
    },

    getCartera: async (nroBanco: number): Promise<Cartera> => {
        const response = await api.get<Cartera>(`/api/CarteraBancos/${nroBanco}`);
        return response.data;
    },

    createCartera: async (cartera: Cartera): Promise<Cartera> => {
        const response = await api.post<Cartera>('/api/CarteraBancos', cartera);
        return response.data;
    },

    updateCartera: async (nroBanco: number, cartera: Cartera): Promise<void> => {
        await api.put(`/api/CarteraBancos/${nroBanco}`, cartera);
    },

    deleteCartera: async (nroBanco: number): Promise<void> => {
        await api.delete(`/api/CarteraBancos/${nroBanco}`);
    },

    getSaldos: async (params?: SaldosCarteraSearchParams): Promise<SaldosCarteraResponse> => {
        const response = await api.get<SaldosCarteraResponse>('/api/CarteraBancos/saldos', {
            params: params ? {
                SearchTerm: params.searchTerm,
                PageNumber: params.pageNumber,
                PageSize: params.pageSize,
                TipoDeCuenta: params.tipoDeCuenta
            } : undefined
        });
        return response.data;
    },

    getMovimientos: async (nroBanco: number, params: MovimientosCarteraSearchParams): Promise<MovimientosCarteraResponse> => {
        const response = await api.get<MovimientosCarteraResponse>(`/api/CarteraBancos/${nroBanco}/movimientos`, {
            params: {
                PageNumber: params.pageNumber,
                PageSize: params.pageSize,
                FechaDesde: params.fechaDesde,
                FechaHasta: params.fechaHasta,
                SearchTerm: params.searchTerm
            }
        });
        return response.data;
    }
};

export default carteraService;

